import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
const API_URL = 'https://apis-csvc-v0-2faa314f421f.herokuapp.com' // <<== da sostituire con variabile d'ambiente in .env
// const API_URL = 'http://localhost:5700' // <<== da sostituire con variabile d'ambiente in .env


//  ========  createAsyncThunk  ========  \\
export const fetchQuestCorrente = createAsyncThunk('questionari/getQuestionarioByUuid', (questionarioUuid) => {

  const endpoint = `${API_URL}/questionari/questionarioByUuid/${questionarioUuid}`;
  // console.log ('fetchQuestCorrente - endpoint: ', endpoint)

  return fetch(endpoint)
      .then(response => {
          if (!response.ok) throw Error(response.statusText)
          return response.json();
      })
      .then(json => json)
  }
)


export const updateRilevanzaAmbiti = createAsyncThunk('questionari/updateRilevanzaAmbitiQuestionario', async (updatedValues) => {

  // console.log('updateRilevanzaAmbiti - updatedValues: ', JSON.stringify(updatedValues))
  const questionarioUuid = updatedValues.questionarioUuid
  const endpoint = `${API_URL}/questionari/rilevanzaAmbiti/${questionarioUuid}`;
  // console.log('updateRilevanzaAmbiti - endpoint: ', endpoint)

  return fetch(endpoint, {
    method: 'PATCH',
    crossDomain: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updatedValues)
  })
  .then(response => {
      if (!response.ok) throw Error(response.statusText)
      return response.json();
  })
  .then(json => json)
});


export const updateKpi = createAsyncThunk('questionari/updateKpiQuestionario', async (updatedValues) => {

  // console.log('updateKpiQuestionario - updatedValues: ', JSON.stringify(updatedValues))
  const questionarioUuid = updatedValues.questionarioUuid
  const endpoint = `${API_URL}/questionari/kpi/${questionarioUuid}`;
  // console.log('updateKpiQuestionario - endpoint: ', endpoint)

  return fetch(endpoint, {
    method: 'PATCH',
    crossDomain: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updatedValues)
  })
  .then(response => {
      if (!response.ok) throw Error(response.statusText)
      return response.json();
  })
  .then(json => json)
});

export const updateImpatto = createAsyncThunk('questionari/updateImpattoQuestionario', async (updatedValues) => {
  // console.log('updateImpattoQuestionario - updatedValues: ', JSON.stringify(updatedValues))
  const questionarioUuid = updatedValues.questionarioUuid
  const endpoint = `${API_URL}/questionari/impatto/${questionarioUuid}`;
  // console.log('updateImpattoQuestionario - endpoint: ', endpoint)

  return fetch(endpoint, {
    method: 'DELETE',
    crossDomain: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updatedValues)
  })
  .then(response => {
      if (!response.ok) throw Error(response.statusText)
      return response.json();
  })
  .then(json => json)
});

export const updateSelezioneAmbiti = createAsyncThunk('questionari/updateSelezioneAmbiti', async (updatedValues) => {
  // console.log('updateSelezioneAmbiti - updatedValues: ', JSON.stringify(updatedValues))
  const questionarioUuid = updatedValues.questionarioUuid
  const endpoint = `${API_URL}/questionari/selezioneAmbiti/${questionarioUuid}`;
  console.log('updateSelezioneAmbiti - endpoint: ', endpoint)

  return fetch(endpoint, {
    method: 'PATCH',
    crossDomain: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updatedValues)
  })
  .then(response => {
      if (!response.ok) throw Error(response.statusText)
      return response.json();
  })
  .then(json => json)

});


export const updateSelezioneStakeholders = createAsyncThunk('questionari/updateSelezioneStakeholders', async (updatedValues) => {

  // console.log('updateSelezioneStakeholders - updatedValues: ', JSON.stringify(updatedValues))
  const questionarioUuid = updatedValues.questionarioUuid
  const endpoint = `${API_URL}/questionari/selezioneStakeholders/${questionarioUuid}`;
  console.log('updateSelezioneStakeholders - endpoint: ', endpoint)

  return fetch(endpoint, {
    method: 'PATCH',
    crossDomain: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updatedValues)
  })
  .then(response => {
      if (!response.ok) throw Error(response.statusText)
      return response.json();
  })
  .then(json => json)

});


export const updateSelezioneAnni = createAsyncThunk('questionari/updateSelezioneAnni', async (updatedValues) => {

  // console.log('updateSelezioneAnni - updatedValues: ', JSON.stringify(updatedValues))
  const questionarioUuid = updatedValues.questionarioUuid
  const endpoint = `${API_URL}/questionari/selezioneAnni/${questionarioUuid}`;
  console.log('updateSelezioneAnni - endpoint: ', endpoint)

  return fetch(endpoint, {
    method: 'PATCH',
    crossDomain: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updatedValues)
  })
  .then(response => {
      if (!response.ok) throw Error(response.statusText)
      return response.json();
  })
  .then(json => json)

});



export const updateAnalisiStrategica = createAsyncThunk('questionari/updateAnalisiStrategica', async (updatedValues) => {

  // console.log('updateSelezioneAnni - updatedValues: ', JSON.stringify(updatedValues))
  const questionarioUuid = updatedValues.questionarioUuid
  const endpoint = `${API_URL}/questionari/analisiStrategica/${questionarioUuid}`;
  console.log('updateAnalisiStrategica - endpoint: ', endpoint)

  return fetch(endpoint, {
    method: 'PATCH',
    crossDomain: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updatedValues)
  })
  .then(response => {
      if (!response.ok) throw Error(response.statusText)
      return response.json();
  })
  .then(json => json)

});


export const insertImpatto = createAsyncThunk('questionari/insertImpattoQuestionario', async (updatedValues) => {
  // console.log('insertImpattoQuestionario - updatedValues: ', JSON.stringify(updatedValues))
  const questionarioUuid = updatedValues.questionarioUuid
  const endpoint = `${API_URL}/questionari/impatto/${questionarioUuid}`;
  // console.log('insertImpattoQuestionario - endpoint: ', endpoint)

  return fetch(endpoint, {
    method: 'POST',
    crossDomain: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updatedValues)
  })
  .then(response => {
      if (!response.ok) throw Error(response.statusText)
      return response.json();
  })
  .then(json => json)
});

export const updateContoEconomico = createAsyncThunk('questionari/updateContoEconomico', async (updatedValues) => {
  // console.log('updateContoEconomico - updatedValues: ', JSON.stringify(updatedValues))
  const questionarioUuid = updatedValues.questionarioUuid
  const endpoint = `${API_URL}/questionari/updateContoEconomico/${questionarioUuid}`;
  console.log('updateContoEconomico - endpoint: ', endpoint)

  return fetch(endpoint, {
    method: 'PATCH',
    crossDomain: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updatedValues)
  })
  .then(response => {
      if (!response.ok) throw Error(response.statusText)
      return response.json();
  })
  .then(json => json)

});



//  ========  Slice  ========  \\

const questCorrenteSlice = createSlice({
  name:'questCorrente',
  initialState: {
    data: null,
    status: 'idle',
    error: null,

    questionarioUuid: null,
    aziendaNome: null,
    noteQuestionario: null,
    versioneQuestionario: null,
    statoLavorazione: null,
    analisiStrategica: null,
    perPrec: null,
    perCorr: null,
    perSucc: null,

    stakeholders: null,
    ambiti: null,
    rilevanzaAmbiti: null,
    kpis: null, 
    contoEconomico: null,

    test: 'OK-00',
    testValue: 0
  },
  reducers: {
    setQuestionarioCorrente: (state, action) => {
      state.questionarioUuid = action.payload.questionarioUuid;
      state.aziendaNome = action.payload.aziendaNome;
      state.noteQuestionario = action.payload.noteQuestionario;
    },

    setValoreRilevanza: (state, action) => {
        const { topic, impact, value } = action.payload;
        state.rilevanzaAmbiti = state.rilevanzaAmbiti.map(item => {
            if (item.topic === topic) {
                return impact === 'io' ? { ...item, io: Number(value) } : { ...item, oi: Number(value) };
            }
            return item;
        });
    },

    setValoreKpis: (state) => {
      state.kpis = state.kpis.map(item => {
          return item;
      });
    },
  },
  extraReducers: builder => {

    // Step 1 - fetchQuestCorrente: Gestire lo stato della fetchQuestCorrente
    builder.addCase(fetchQuestCorrente.pending,     (state) => {
        state.status = 'loading'
    })

    builder.addCase(fetchQuestCorrente.fulfilled,   (state, action) => {
        state.status = 'succeded'
        // state.data = action.payload         // from createAsyncThunk
        state.questionarioUuid = action.payload[0].questionarioUuid;
        state.aziendaNome = action.payload[0].aziendaNome;
        state.noteQuestionario = action.payload[0].noteQuestionario;
        state.versioneQuestionario = action.payload[0].versioneQuestionario;
        state.statoLavorazione = action.payload[0].statoLavorazione;
        state.perPrec = action.payload[0].perPrec;
        state.perCorr = action.payload[0].perCorr;
        state.perSucc = action.payload[0].perSucc;
        state.stakeholders = action.payload[0].stakeholders;
        state.ambiti = action.payload[0].ambiti;
        state.rilevanzaAmbiti = action.payload[0].rilevanzaAmbiti;
        state.kpis = action.payload[0].kpis;
        state.contoEconomico = action.payload[0].contoEconomico;
        state.analisiStrategica = action.payload[0].analisiStrategica;    // 2025-07-17 : Aggiunta questa riga
    })

    builder.addCase(fetchQuestCorrente.rejected,    (state, action) => {
        state.loading = 'failed'
        state.error = action.error.message  // from createAsyncThunk    
    })

    // Step 2 - updateRilevanzaAmbiti: Gestire lo stato dell'aggiornamento nel slice
    .addCase(updateRilevanzaAmbiti.pending, (state) => {
      state.status = 'updating';
    })

    // .addCase(updateRilevanzaAmbiti.fulfilled, (state, action) => {
    .addCase(updateRilevanzaAmbiti.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.rilevanzaAmbiti = action.payload.rilevanzaAmbiti;
        /*
        state.rilevanzaAmbiti = state.rilevanzaAmbiti.map(item => {
            const updatedItem = action.payload.find(updated => updated.topic === item.topic);
            return updatedItem ? updatedItem : item;
        });
        */
    })

    .addCase(updateRilevanzaAmbiti.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
    })

    // Step 3 - updateKpi: Gestire lo stato dell'aggiornamento del kpi nel slice
    .addCase(updateKpi.pending, (state) => {
      state.status = 'updating';
    })

    // .addCase(updateRilevanzaAmbiti.fulfilled, (state, action) => {
    .addCase(updateKpi.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.kpis = action.payload.kpis;
        /*
        state.rilevanzaAmbiti = state.rilevanzaAmbiti.map(item => {
            const updatedItem = action.payload.find(updated => updated.topic === item.topic);
            return updatedItem ? updatedItem : item;
        });
        */
    })

    .addCase(updateKpi.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
    });

    // Step 4 - updateImpatto: Gestire lo stato della AsyncThunk updateImpatto
    builder.addCase(updateImpatto.pending,     (state) => {
      state.status = 'loading'
    })

    builder.addCase(updateImpatto.fulfilled,   (state, action) => {
        state.status = 'succeded'
        state.stakeholders = action.payload.stakeholders;
        state.ambiti = action.payload.ambiti;
        state.rilevanzaAmbiti = action.payload.rilevanzaAmbiti;
        state.kpis = action.payload.kpis;
    })

    builder.addCase(updateImpatto.rejected,    (state, action) => {
        state.loading = 'failed'
        state.error = action.error.message  // from createAsyncThunk    
    })


    // Step 5 - updateSelezioneAmbiti: Gestire lo stato della AsyncThunk updateSelezioneAmbiti
    builder.addCase(updateSelezioneAmbiti.pending,     (state) => {
      state.status = 'loading'
    })

    builder.addCase(updateSelezioneAmbiti.fulfilled,   (state, action) => {
        state.status = 'succeded'
        state.ambiti = action.payload.ambiti;
    })

    builder.addCase(updateSelezioneAmbiti.rejected,    (state, action) => {
        state.loading = 'failed'
        state.error = action.error.message  // from createAsyncThunk    
    })

    // Step 6 - updateSelezioneStakeholders: Gestire lo stato della AsyncThunk updateSelezioneStakeholders
    builder.addCase(updateSelezioneStakeholders.pending,     (state) => {
      state.status = 'loading'
    })

    builder.addCase(updateSelezioneStakeholders.fulfilled,   (state, action) => {
        state.status = 'succeded'
        state.stakeholders = action.payload.stakeholders;
    })

    builder.addCase(updateSelezioneStakeholders.rejected,    (state, action) => {
        state.loading = 'failed'
        state.error = action.error.message  // from createAsyncThunk    
    })

    // Step 7 - updateSelezioneAnni: Gestire lo stato della AsyncThunk updateSelezioneAnni
    builder.addCase(updateSelezioneAnni.pending,     (state) => {
      state.status = 'loading'
    })

    builder.addCase(updateSelezioneAnni.fulfilled,   (state, action) => {
        state.status = 'succeded'
        state.perPrec = action.payload.perPrec;
        state.perCorr = action.payload.perCorr;
        state.perSucc = action.payload.perSucc;
    })

    builder.addCase(updateSelezioneAnni.rejected,    (state, action) => {
        state.loading = 'failed'
        state.error = action.error.message  // from createAsyncThunk    
    })

    // Step 8 - updateAnalisiStrategica
    builder.addCase(updateAnalisiStrategica.pending,     (state) => {
      state.status = 'loading'
    })

    builder.addCase(updateAnalisiStrategica.fulfilled,   (state, action) => {
        state.status = 'succeded'
        state.analisiStrategica = action.payload.analisiStrategica;
    })

    builder.addCase(updateAnalisiStrategica.rejected,    (state, action) => {
        state.loading = 'failed'
        state.error = action.error.message  // from createAsyncThunk    
    })

    // Step 9 - insertImpatto: Gestire lo stato della AsyncThunk insertImpatto
    builder.addCase(insertImpatto.pending,     (state) => {
      state.status = 'loading'
    })

    builder.addCase(insertImpatto.fulfilled,   (state, action) => {
        state.status = 'succeded'
        state.stakeholders = action.payload.stakeholders;
        state.ambiti = action.payload.ambiti;
        state.rilevanzaAmbiti = action.payload.rilevanzaAmbiti;
        state.kpis = action.payload.kpis;
    })

    builder.addCase(insertImpatto.rejected,    (state, action) => {
        state.loading = 'failed'
        state.error = action.error.message  // from createAsyncThunk    
    })


    // Step 10 - updateContoEconomico: Gestire lo stato della AsyncThunk updateContoEconomico
    builder.addCase(updateContoEconomico.pending,     (state) => {
      state.status = 'loading'
    })

    builder.addCase(updateContoEconomico.fulfilled,   (state, action) => {
        state.status = 'succeded'
        state.contoEconomico = action.payload.contoEconomico;
    })

    builder.addCase(updateContoEconomico.rejected,    (state, action) => {
      state.loading = 'failed'
      state.error = action.error.message  // from createAsyncThunk    
    })

}   
})

// updateContoEconomico



export const { setQuestionarioCorrente, setValoreRilevanza, setValoreKpis } = questCorrenteSlice.actions;
export const questCorrenteReducer = questCorrenteSlice.reducer;

/*
    In questo modo, hai separato l'aggiornamento del backend in un asyncThunk e hai gestito gli stati di pending, fulfilled, 
    e rejected nel tuo slice. 
    Puoi chiamare dispatch(updateTopicsRelevance({ applicationUuid, updatedValue })) quando vuoi aggiornare i valori nel backend.
*/

/*
    // Remove update logic from setTopicsRelevanceValue reducer:

      const arrayElementToUpdate = action.payload
      const ambito    = arrayElementToUpdate.ambito
      const effetto   = arrayElementToUpdate.effetto
      const valore    = arrayElementToUpdate.valore
  
      state.rilevanzaAmbiti = (effetto==='io') ? 
        state.rilevanzaAmbiti.map(item => {
          if (item.ambito === ambito) { return { ...item, io: Number(valore) } }
          return item
        })     
      : (effetto==='oi') ? state.rilevanzaAmbiti.map(item => {
          if (item.ambito === ambito) { return { ...item, oi: Number(valore) } }
          return item
      })      
      : state.rilevanzaAmbiti.map(item => {
          return item
      })		


*/